<form-wrapper header="Ошибка">
	<div class="app-text__body-m mbi-7">Во время обработки запроса произошла ошибка</div>
	<app-button appearance="outline" routerLink="/login" queryParamsHandling="preserve">
		OK
	</app-button>
</form-wrapper>